@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.leftContent {
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: flex-start;

  @include for-phone-only {
    margin-top: 18px;
  }
}

.title {
  margin-bottom: 12px;
}

.mainContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.termsOfServiceAndPrivacyPolicy {
  @include sm-regular;

  color: var(--neutral-40);

  margin: 0 auto;
  max-width: 100%;
  text-align: center;
}

.tosContainer {
  display: flex;
  justify-content: flex-start !important;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.messageText {
  text-align: center;
  max-width: 500px;
  font-size: 15px;
  @include for-phone-only {
    line-break: auto;
    max-width: 90%;
  }

  .bold {
    font-weight: 700;
  }
}

.imgBackgroundFull {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 185px;
  @include for-phone-only {
    margin-bottom: unset;
    background-image: url('https://res.cloudinary.com/almanac/image/upload/v1714580671/blaze_assets/backgrounds/first_time_experience/verify_final_m8wcsi.png');
    height: 100%;
    justify-content: unset;
    border-radius: unset;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.errorContainer {
  max-width: 344px;
  svg {
    align-self: flex-start;
  }
}

.backToStartButton {
  &:focus {
    @include reg-selected-shadow;
  }
}

.buttonContainer {
  margin-top: 48px;
  @media (max-width: $phoneMaxWidth) {
    margin-top: 32px;
  }
}

.verificationCode {
  padding: 56px 0 0 0;
  margin-bottom: 4px;
  width: 100% !important;

  @include for-phone-only {
    padding-top: 36px;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  input[type='tel'] {
    @include xxl-sohne;
    text-align: center;
    font-size: 32px;
    caret-color: #0b7dd0 !important;
    font-style: normal;
    font-weight: 400;
    line-height: 142%;
    letter-spacing: -0.32px;
    color: var(--neutral-90);
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background-color: var(--light-100);
    margin: 0 7px;
    font-size: 28px;
    line-height: 142%;
    width: 20% !important;
    max-width: 72px;
    min-height: 98px;

    &:not(:focus) {
      @include blur(50px);
      background-color: var(--dark-4, rgba(0, 0, 0, 0.04));
      border: none;
    }
  }

  input[type='tel']:focus {
    outline: none;
    border: 2px solid #0b7dd0;
  }

  input[type='tel']:focus + input {
    border-left: 1px solid var(--neutral-10);
  }
}

.footer {
  padding-top: 95px;
}
